import { SubscriptionKind } from 'core/lib/graphql/types.d';

export const subscriptionPlanLabelDict = {
  [SubscriptionKind.Monthly]: 'Mensal',
  [SubscriptionKind.Biannual]: 'Semestral',
  [SubscriptionKind.Yearly]: 'Anual',
  [SubscriptionKind.Free]: 'Grátis',
  [SubscriptionKind.CoffeePass]: 'Coffee Pass',
};
